import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { asyncMap } from "@mittwald/awesome-node-utils/misc/arrayHelpers";
import { Customer } from "../../../customer/Customer";
import type { FinderProfileListItemData } from "../types";
import type { FinderProfileBehaviors } from "./types";

export const apiFinderProfileBehaviors = (
  client: MittwaldAPIV2Client,
): FinderProfileBehaviors => ({
  find: async (customerId) => {
    const response = await client.leadFyndr.leadfyndrGetLeadFyndrProfile({
      customerId,
    });

    if (response.status === 200) {
      return response.data;
    }
  },

  list: async () => {
    const customerList = await Customer.query().execute();

    const customersAndFinderProfile = await asyncMap(
      customerList.items,
      async (customer) => {
        const finderProfileResult =
          await client.leadFyndr.leadfyndrGetLeadFyndrProfile({
            customerId: customer.id,
          });

        return finderProfileResult.status === 200
          ? finderProfileResult.data
          : undefined;
      },
    );

    const finderProfiles = customersAndFinderProfile.filter(
      (e) => e !== undefined,
    ) as FinderProfileListItemData[];

    return {
      items: finderProfiles,
      totalCount: finderProfiles.length,
    };
  },

  findContract: async (customerId) => {
    const response = await client.contract.getDetailOfContractByLeadFyndr({
      customerId,
    });

    if (response.status === 200) {
      return response.data;
    }
  },
});
